const humanify = value =>
  value
    .split("_")
    .map(w => w.charAt(0).toUpperCase() + w.slice(1))
    .join(" ");

export default humanify;


// WEBPACK FOOTER //
// ./utils/humanify.js